__turbopack_context__.v({
  "keycap": "Keycap-module__HCYNfa__keycap",
  "keycapHovered": "Keycap-module__HCYNfa__keycapHovered",
  "keycapSearch": "Keycap-module__HCYNfa__keycapSearch",
});
